import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import StoreFinderImportModal from "./StoreFinderImportModal";
import {endUploadLocationsAction, uploadLocationsAction} from "./actions";
import {formDataManager} from "../../hoc/formDataManager";

const mapStateToProps = (state) => {
    return {
        locationsUploaded: state.storeFinderImport.uploaded,
        modalOpen: state.storeFinderImport.uploading
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleClose: () => dispatch(endUploadLocationsAction()),
        onSaveData: (data) => dispatch(uploadLocationsAction(data.file))
    }
};

const StoreFinderImportModalConnected = connect(mapStateToProps, mapDispatchToProps);

const StoreFinderImportModalFormDataManager = formDataManager({});

const StoreFinderImportModalComposed = compose(
    StoreFinderImportModalConnected,
    StoreFinderImportModalFormDataManager
)(StoreFinderImportModal);

export default StoreFinderImportModalComposed;



// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/StoreFinderImportModalContainer.jsx